import { Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import FormOne from "./FormOne";
import FormThree from "./FormThree";
import { colors } from "../../css components/Style";
import EditButtons from "../../../components/EditButtons";
import { CancelButton } from "../../css components/Button";
import { ButtonFooter, PageHeader, Paper } from "../../../components";
import Agreement from "../agreement components/Agreement";

export default function FormDisplay({
  agencyID,
  brandID,
  formikProps,
  editState,
  setEditState,
}) {
  const { state } = useLocation();
  const navigate = useNavigate();
  return (
    <Grid container spacing={4} style={{ padding: "20px" }}>
      <Grid size={12}>
        <PageHeader
          buttons={[
            formikProps.values.is_brand_verified === 1 ||
            formikProps.values.is_agency_verified === 1 ? (
              <CancelButton variant="outlined" onClick={() => navigate(-1)}>
                Back
              </CancelButton>
            ) : (
              <EditButtons editState={editState} setEditState={setEditState} />
            ),
          ]}
          pageName={"Company Details & Agreement"}
          pageHeader="Manage organization info and compliance agreements."
        />
      </Grid>

      <Grid size={12}>
        {formikProps.values.is_brand_verified === 1 && (
          <Paper>
            <Grid size={12}>
              <Typography variant="h6" color={colors.success}>
                This brand has been verified by admin.
              </Typography>
            </Grid>
          </Paper>
        )}
      </Grid>

      <Grid size={12}>
        <Paper>
          <FormOne
            agencyID={agencyID}
            brandID={brandID}
            formikProps={formikProps}
            editState={editState}
          />
          <FormThree
            agencyID={agencyID}
            brandID={brandID}
            formikProps={formikProps}
            editState={editState}
          />
        </Paper>

        {formikProps.values.ID &&
          formikProps.values.mandatoryDetailsSubmitted && (
            <Paper>
              <Agreement
                agencyID={agencyID}
                setEditState={setEditState}
                brandID={brandID}
                formikProps={formikProps}
              />
            </Paper>
          )}
      </Grid>

      {editState && (
        <Grid size={12}>
          <ButtonFooter
            disabled={!formikProps.values.verifyNumber}
            editState={editState}
            route={state}
            setEditState={setEditState}
            ID={formikProps.values.ID}
            formikProps={formikProps}
          />
        </Grid>
      )}
    </Grid>
  );
}
